import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./bootstrapperIcons.html";
import { IS_DEVELOPMENT } from '../../../config';
import apiTemplate from './apiIcon.html';
import consultantTemplate from './consultantIcon.html';
import packageTemplate from './packageIcon.html';
const ICON_TEMPLATES = {
  package: packageTemplate,
  api: apiTemplate,
  consultant: consultantTemplate
};

/**
 * @typedef {`bootstrapper:${keyof typeof ICON_TEMPLATES}`} BootstrapperIcon
 */

class BootstrapperIcons extends LightningElement {
  constructor(...args) {
    super(...args);
    /** @type {keyof typeof ICON_TEMPLATES} */
    this.type = void 0;
    /** @type {string} */
    this.alternativeText = '';
    /** @type {string} */
    this.width = '62px';
    /** @type {string} */
    this.height = '62px';
  }
  render() {
    const template = ICON_TEMPLATES[this.type];
    if (!template && IS_DEVELOPMENT) {
      throw new Error(`Unknown bootstrapper icon type '${this.type}'`);
    }
    return template;
  }
  /*LWC compiler v7.1.3*/
}
BootstrapperIcons.delegatesFocus = true;
_registerDecorators(BootstrapperIcons, {
  publicProps: {
    type: {
      config: 0
    },
    alternativeText: {
      config: 0
    },
    width: {
      config: 0
    },
    height: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(BootstrapperIcons, {
  tmpl: _tmpl,
  sel: "appx-bootstrapper-icons",
  apiVersion: 62
});
export default __lwc_component_class_internal;